module.exports = __webpack_public_path__ + "assets/img/about-link-btn.cfc568f2.svg";